export const links = [
  {
    url: '/games',
    name: 'Games',
  },
  {
    url: '/',
    name: 'Home',
  },
  {
    url: '/account',
    name: 'Account',
  },
];
